import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onScrollToTop", "onScrollFromBottom", "onScrollToBottom", "isSpotlight", "stickToTop", "topThreshold", "bottomThreshold"];
import styled from 'styled-components';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import VizExScrollFade from 'visitor-ui-component-library/scroll/VizExScrollFade';
import { scrollbarCss } from 'visitor-ui-component-library/scroll/scrollbarCss';
import { WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollFadeContainer = styled(VizExScrollFade).withConfig({
  displayName: "ScrollWrapper__ScrollFadeContainer"
})(["flex:1;min-height:0;display:flex;flex-direction:column;"]);
const Wrapper = styled.div.withConfig({
  displayName: "ScrollWrapper__Wrapper"
})(["flex:1;overflow-y:auto;display:flex;flex-direction:column-reverse;align-self:stretch;padding:8px 0px;", ""], ({
  $isSpotlight
}) => $isSpotlight && scrollbarCss);
const Spacer = styled.div.withConfig({
  displayName: "ScrollWrapper__Spacer"
})(["flex:1 1 0px;"]);
const ScrollWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      onScrollToTop = () => {},
      onScrollFromBottom = () => {},
      onScrollToBottom = () => {},
      isSpotlight = false,
      stickToTop = null,
      topThreshold = 300,
      bottomThreshold = 300
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOnTop, setIsOnTop] = useState(false);
  const [isOnBottom, setIsOnBottom] = useState(true);
  useEffect(() => {
    if (isOnTop) onScrollToTop();
  }, [isOnTop, onScrollToTop]);
  useEffect(() => {
    if (!isOnBottom) {
      onScrollFromBottom();
    } else {
      onScrollToBottom();
    }
  }, [isOnBottom, onScrollToBottom, onScrollFromBottom]);
  const onWrapperScroll = useCallback(e => {
    const {
      scrollHeight,
      clientHeight,
      scrollTop
    } = e.target;
    if (scrollHeight - clientHeight - Math.abs(scrollTop) <= topThreshold) {
      setIsOnTop(true);
    } else {
      setIsOnTop(false);
    }
    if (Math.abs(scrollTop) >= bottomThreshold) {
      setIsOnBottom(false);
    } else {
      setIsOnBottom(true);
    }
  }, [topThreshold, bottomThreshold]);
  useEffect(() => {
    if (ref && typeof ref !== 'function' && ref.current) {
      const {
        current
      } = ref;
      current.addEventListener('scroll', onWrapperScroll, {
        passive: true
      });
      return () => {
        current.removeEventListener('scroll', onWrapperScroll);
      };
    }
  }, [ref, onWrapperScroll]);
  const wrapper = /*#__PURE__*/_jsxs(Wrapper, Object.assign({
    "data-test-id": "scroll-container",
    $isSpotlight: isSpotlight
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(Spacer, {}), children, stickToTop]
  }));
  if (isSpotlight) {
    return /*#__PURE__*/_jsx(ScrollFadeContainer, {
      reverseScroll: true,
      backgroundColor: WHITE,
      children: wrapper
    });
  }
  return wrapper;
});
ScrollWrapper.displayName = 'ScrollWrapper';
export default ScrollWrapper;